/* eslint-disable max-lines-per-function */
import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import { Card } from 'primereact/card';
import FundoAmarelo from '../../assets/fundo_amarelo.png';
import PickListServicosAdicionais from './atom/PickListServicosAdicionais.jsx';
import servicosAdicionaisService from '../../services/servicosAdicionais/servicosAdicionaisService';
// eslint-disable-next-line import/no-unresolved
import Resumo from '../resumo/Resumo';
import { BuscarDependentes } from '../../services/dependentes';
import { BuscarAssoc } from '../../services/associados';
import { Button } from 'primereact/button';
import { retornoEtapasCadastro } from './defineSteps';

import './style.css';
import { retornaServicosParaInserirOuDeletar } from './functions';
import { makePayloadDeletarServicoAdicionais, makePayloadInserirServicoAdicionais } from '../../services/servicosAdicionais/ServicosAdicionaisMakePayload';
import { Growl } from 'primereact/growl';
// eslint-disable-next-line import/no-unresolved
import Loading from './atom/loading';
import ModalPlanoDesativado from '../modalPlanoDesativado/modalPlanoDesativado';

const header = <img alt="Card" src={FundoAmarelo} />;

export default function CadastrarServicosAdicionais(props) {
    const history = useHistory();
    const { inscricao } = props.match.params;
    const [possuiServicosAdicionais, setPossuiServicosAdicionais] = useState(false);
    const [servicosAdicionaisIniciais, setServicosAdicionaisIniciais] = useState([]);
    const [servicosAdicionais, setServicosAdicionais] = useState([{}]);
    const [servicosAdicionaisSelecionados, setServicosAdicionaisSelecionados] = useState([]);

    const [loadingChamadaBack, setLoadingChamadaBack] = useState(false);
    const [mostarResumo, setMostarResumo] = useState(false);
    const [Dependentes, setDependentes] = useState([]);
    const [Associado, setAssociado] = useState({});

    const [isFirstRender, setIsFirstRender] = useState(true);

    const [totalServicosAdicionais, setTotalServicosAdicionais] = useState(0);

    const growl = useRef(null);

    const sleep = ms => new Promise(
        resolve => setTimeout(resolve, ms)
    );

    const mensagemDeErro = message => {
        growl.current.show({
            severity: 'error',
            summary: '',
            detail: message,
            life: 4000
        });
    };

    const mensagemDeSucesso = message => {
        growl.current.show({
            severity: 'success',
            summary: '',
            detail: message,
            life: 4000
        });
    };

    const mensagemDeAviso = message => {
        growl.current.show({
            severity: 'warn',
            summary: '',
            detail: message,
            sticky: true,
            closable: false
        });
    };

    function limparMensagens() {
        growl.current.clear();
    }

    const loadAssociado = async () => {
        try {
            const responseBuscaAssociado = BuscarAssoc(inscricao);

            setAssociado(responseBuscaAssociado[0]);
        } catch (err) {
            throw new Error(err);
        }
    };

    async function loadInfos() {
        try {
            await sleep(100);

            setLoadingChamadaBack(true);

            const [servicosAdicionaisCadastrados, dependentes, associado] = await Promise.all([

                servicosAdicionaisService.buscarServicosAdicionaisCadastrados(inscricao),
                BuscarDependentes(inscricao),
                BuscarAssoc(inscricao)
            ]);

            const servicosAdicionaisResponse = await servicosAdicionaisService.buscarServicosAdicionais(associado[0].CodigoCidadeIbge);

            setAssociado(associado[0]);
            setDependentes(dependentes ? dependentes : []);

            if (servicosAdicionaisResponse.length === 0) {
                setLoadingChamadaBack(false);

                return;
            }

            setPossuiServicosAdicionais(true);

            const servicosAdicionaisCadastradosIds = servicosAdicionaisCadastrados.map(servico => servico?.Taxa.id);

            const servicosAdicionaisfilter = servicosAdicionaisResponse
                .filter(servico => !servicosAdicionaisCadastradosIds.includes(servico.id));

            const servicosAdicionaisIniciaisAux = servicosAdicionaisCadastrados.map(servico => servico?.Taxa);

            setServicosAdicionaisIniciais(servicosAdicionaisCadastradosIds);
            setServicosAdicionaisSelecionados(servicosAdicionaisIniciaisAux);
            setServicosAdicionais(servicosAdicionaisfilter);

            setLoadingChamadaBack(false);
        } catch (error) {
            mensagemDeErro('Não foi possível carregar as informações, tente novamente mais tarde!');
            setLoadingChamadaBack(false);
        }
    }

    useEffect(() => {
        loadInfos();
    }, []);

    useEffect(() => {
        setLoadingChamadaBack(true);
        loadAssociado();
        setLoadingChamadaBack(false);
    }, [inscricao]);

    async function salvarServicosAdicionais(event) {
        const servicosAdicionaisSelecionadosIds = event.target.map(({ id }) => id);

        const [servicosParaInserir, servicosParaDeletar] = retornaServicosParaInserirOuDeletar(servicosAdicionaisSelecionadosIds, servicosAdicionaisIniciais);

        setIsFirstRender(false);

        if (servicosParaInserir.length || servicosParaDeletar.length) {
            try {
                setLoadingChamadaBack(true);

                const inserirPayload = makePayloadInserirServicoAdicionais(inscricao, servicosParaInserir);
                const deletarPayload = makePayloadDeletarServicoAdicionais(inscricao, servicosParaDeletar);

                servicosParaInserir.length && await servicosAdicionaisService.inserirServicosAdicionais(inserirPayload);

                servicosParaDeletar.length && await servicosAdicionaisService.deletarServicosAdicionais(deletarPayload);

                setServicosAdicionaisIniciais(servicosAdicionaisSelecionadosIds);

                setLoadingChamadaBack(false);
                setServicosAdicionais(event.source);
                setServicosAdicionaisSelecionados(event.target);
                limparMensagens();
                mensagemDeSucesso('Dados salvos com sucesso!');
            } catch (error) {
                setLoadingChamadaBack(false);
                mensagemDeErro('Não foi possível atualizar os serviços, tente novamente mais tarde!');
            }
        }
    }

    useEffect(() => {
        setTotalServicosAdicionais(servicosAdicionaisSelecionados.reduce((accumulator, currentValue) => accumulator + currentValue?.valor ?? 0, 0));
    }, [servicosAdicionaisSelecionados]);

    return (
        <Card className='tratar-scroll-card' header={header} title="Cadastrar Servicos Adicionais">
            <Growl ref={growl} />
            <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                {retornoEtapasCadastro()}
            </div>
            {loadingChamadaBack &&
                servicosAdicionaisSelecionados.length === 0 &&
                isFirstRender &&
                <Loading />}
            {Associado && Associado.Aceite !== 'S' && <ModalPlanoDesativado
                mostrarFooter={true}
                status={Associado['ProdutosPreco.status']}
                plano={Associado['Produto.descricao']}
                cidade={Associado.Cidade}
                inscricao={Associado.Inscricao}
                closable={false}
            />}
            {possuiServicosAdicionais && Associado?.Aceite !== 'S' && <>
                <PickListServicosAdicionais
                    setServicosAdicionais={setServicosAdicionais}
                    setServicosAdicionaisSelecionados={setServicosAdicionaisSelecionados}
                    servicosAdicionaisSelecionados={servicosAdicionaisSelecionados}
                    servicosAdicionais={servicosAdicionais}
                    loading={loadingChamadaBack}
                    onChange={salvarServicosAdicionais} />
                <div className='valorServicos'>
                    <span className='spanValor'>{totalServicosAdicionais.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}</span>
                </div>
            </>}
            {!possuiServicosAdicionais && !loadingChamadaBack && Associado?.Aceite !== 'S' && <p className='servicoNaoDisponivel'>Nenhum serviço disponível para a região desse contrato.</p>}
            {!possuiServicosAdicionais && !loadingChamadaBack && Associado?.Aceite === 'S' && <p className='servicoNaoDisponivel'>Não é permitido cadastrar serviços adicionais para associados que já possuem aceite de contrato</p>}
            <div className="p-grid p-fluid proximo">
                <div className="p-col-12 p-md-4 p-lg-4 p-sm-4">
                    <Button
                        disabled={loadingChamadaBack}
                        label="Próximo"
                        icon="pi pi-check"
                        iconPos="left"
                        onClick={() => setMostarResumo(true)}
                    />
                </div>
                <div className="p-col-12 p-md-4 p-lg-4 p-sm-4">
                    <Button
                        disabled={Associado?.Aceite === 'S'}
                        label="Editar Contrato"
                        type="button"
                        onClick={() => history.push(`/editar-contrato/${inscricao}`)}
                    />
                </div>
            </div>
            {mostarResumo && <Resumo
                valorServicosAdicionais={setTotalServicosAdicionais}
                Associado={Associado}
                setShowModal={setMostarResumo}
                setLoading={setLoadingChamadaBack}
                inscricao={inscricao}
                showModal={mostarResumo}
                Dependentes={Dependentes}
            />}

        </Card>
    );
}
